import { resolveStreamChannel } from '@fetmode/types';
export function matchesStreamChannel(signal, channel) {
    if (signal.kind === 'peer.left') {
        return true;
    }
    return resolveStreamChannel(signal.channel) === channel;
}
//# sourceMappingURL=channel.js.map